import { useSearch } from "features/search/context"
import { LogCondition, useWebLogTags } from "interface/kojin/log"
import { useMemo } from "react"

type useKojinCareNetTagProps = {
	personalId: string | undefined | null
	condition: LogCondition
}
export const useKojinCareNetTag = ({
	personalId,
	condition
}: useKojinCareNetTagProps) => {
	const search = useSearch()
	const tagsState = useWebLogTags(personalId, condition)
	const {
		clientList,
		departmentList,
		diseaseList,
		drugList,
		otherTagList,
	} = useMemo(
		() => {
			const targetDrugs = search?.drug?.flatMap(drug => drug.drugName.split('/')) ?? []
			return {
				clientList: tagsState.data?.client ?? [],
				departmentList: tagsState.data?.department ?? [],
				diseaseList: tagsState.data?.disease ?? [],
				drugList: tagsState.data?.drug?.map(drug => ({
					...drug,
					isTarget: targetDrugs.some(target => drug.tag.startsWith(target))
				})) ?? [],
				otherTagList: tagsState.data?.other ?? []
			}
		},
		[search, tagsState.data]
	)
	return {
		loading: tagsState.loading,
		error: tagsState.error,
		clientList,
		departmentList,
		diseaseList,
		drugList,
		otherTagList
	}	
}